WiseMetering.Views.NewNavigatorConfiguration = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'integration_configuration',
    template: 'templates/integration_configurations/navigator/new',
    title: () => i18next.t('modal.title.integration_configurations.new')
});
